import React, {PropTypes} from 'react';
import Link from 'shared/Link.jsx';

const JumbotronLink = ({
  message,
  linkPath,
  linkText
}) => (
  <div className="jumbotron">
    <p>{message}</p>
    <p><Link
      to={linkPath}
      className="btn btn-primary btn-lg"
    >{linkText}</Link></p>
  </div>
);

JumbotronLink.propTypes = {
  message: PropTypes.string.isRequired,
  linkPath: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired
};

export default JumbotronLink;



// WEBPACK FOOTER //
// ./src/features/shared/JumbotronLink.jsx